/**
 * FilterBar — the pinned, full-bleed control strip every Performance
 * surface heads with (Real users, Audits, Field data).
 *
 * Full-bleed via negative margins: the Island's `<main>` pads
 * `p-4 md:px-7 md:py-6`, so the strip shifts out to the padding box and
 * re-pads itself, then pins flush to the top of the scroll container.
 *
 * `flush` also cancels the Island's top padding, so the bar's own `py-3`
 * is the only gap between the page header and the controls — without it
 * the two paddings stack and the row floats. Pass `flush={false}` when
 * something else leads the page (Field data's report banner).
 */
import { cn } from '@/lib/utils';
import type { ReactElement, ReactNode } from 'react';

export function FilterBar({
  children,
  flush = true,
}: {
  children: ReactNode;
  /** True when this strip is the first thing in the Island. */
  flush?: boolean;
}): ReactElement {
  return (
    <div
      className={cn(
        'sticky -top-4 z-20 -mx-4 flex flex-wrap items-center gap-2 border-b border-[var(--color-line-soft)] bg-[var(--color-paper)]/85 px-4 py-3 backdrop-blur-sm md:-top-6 md:-mx-7 md:px-7',
        flush && '-mt-4 md:-mt-6',
      )}
    >
      {children}
    </div>
  );
}
